'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoMedkit = function IoMedkit(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.4 11.3c0.3 0 0.6 0.3 0.6 0.6v22.5c0 0.3-0.3 0.6-0.6 0.6h-33.8c-0.3 0-0.6-0.3-0.6-0.6v-22.5c0-0.3 0.3-0.6 0.6-0.6h9.4v-2.5c0.1-2.2 1.7-3.8 4-3.8h7c2.4 0 3.9 1.6 4 3.8v2.5h9.4z m-21.9-2.2v2.2h10v-2.3c0-0.8-0.7-1.5-1.5-1.5h-7c-0.8 0-1.5 0.7-1.5 1.5v0.1z m12.5 15.9v-5h-5v-5h-5v5h-5v5h5v5h5v-5h5z' })
        )
    );
};

exports.default = IoMedkit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/medkit.js
// module id = 2349
// module chunks = 0